import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getDatabase,
  ref,
  get,
  onValue,
  set,
  off,
} from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBWQKojJtS1FfOKL-B8DeQp9HFe9aBPIx4",
  authDomain: "space-guesser.firebaseapp.com",
  databaseURL:
    "https://space-guesser-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "space-guesser",
  storageBucket: "space-guesser.appspot.com",
  messagingSenderId: "182556658984",
  appId: "1:182556658984:web:d0dcf08a093541b72a541d",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
const PATH = "Model";
export const auth = getAuth(app);

// Convert model to persistence state
export function modelToPersistence(model) {
  return {
    emailAddress: model.emailAddress,
    username: model.username,
    PersonalLeaderboardPromiseState: model.PersonalLeaderboardPromiseState.map(
      (scoreData) => ({
        ...scoreData,
        date: scoreData.date ? scoreData.date.toISOString() : null,
      })
    )
  };
}

// Convert data from Firebase to model state
export function persistenceToModel(dataFromFirebase, model) {
  if (!dataFromFirebase) {
    model.setEmailAddress(null);
    model.setUsername("");
    model.PersonalLeaderboardPromiseState = [];
  } else {
    model.setEmailAddress(dataFromFirebase.emailAddress || model.emailAddress);
    model.setUsername(dataFromFirebase.username || model.username);
    model.PersonalLeaderboardPromiseState = dataFromFirebase.PersonalLeaderboardPromiseState ? dataFromFirebase.PersonalLeaderboardPromiseState.map(scoreData => ({
        ...scoreData,
        date: scoreData.date ? new Date(scoreData.date) : null 
        })) : [];
    }
}

// Save the model state to Firebase
export function saveToFirebase(model) {
  if (model.ready && model.user) {
    const dataToSave = modelToPersistence(model);
    set(ref(db, PATH + "/" + model.user), dataToSave)
      .then(() => console.log("Data saved to Firebase."))
      .catch((error) => {
        console.error("Error saving to Firebase:", error);
      });
  }
}

// Read the model state from Firebase
export function readFromFirebase(model) {
  if (!model.user) {
    console.error("No user logged in to read data.");
    return;
  }

  const firebaseRef = ref(db, PATH + "/" + model.user);
  model.ready = false;

  // Read data from Firebase
  get(firebaseRef)
    .then((snapshot) => {
      const data = snapshot.val();
      persistenceToModel(data, model);
    })
    .then(() => {
      model.ready = true;

      // Set up a listener for real-time updates
      onValue(firebaseRef, (snapshot) => {
        const data = snapshot.val();
        persistenceToModel(data, model);
      });
    })
    .catch((error) => {
      console.error("Error reading from Firebase:", error);
      model.ready = true;
    });
}

// Function to handle authentication state changes
export function connectToFirebase(model, watchFunction) {
  const checkACB = () => [model.user, model.username, model.emailAddress, model.PersonalLeaderboardPromiseState.length];

  const sideEffectACB = async () => {
    await saveToFirebase(model);
  };

  watchFunction(checkACB, sideEffectACB);

  function userChangedACB(user) {
    if (user) {
      model.user = user.uid;
      model.emailAddress = user.email;

      // Read user data from Firebase
      const firebaseRef = ref(db, PATH + "/" + model.user);
      get(firebaseRef)
        .then((snapshot) => {
          const data = snapshot.val();
          if (!data) {
            // Create a new entry for the user if it doesn't exist
            model.setEmailAddress(user.email);
            model.setUsername(model.username);
            model.PersonalLeaderboardPromiseState = [];
            model.ready = true;
            saveToFirebase(model);
          } else {
            persistenceToModel(data, model);
          }
          readFromFirebase(model);
        })
        .catch((error) => {
          console.error("Error reading user data from Firebase:", error);
        });
    } else {
      // User signed out, stop listening to Firebase
      if (model.user) {
        saveToFirebase(model);
        off(ref(db, PATH + "/" + model.user));
      }
      model.user = null;
      model.ready = false;
      model.resetModel();
    }
  }

  // Observe authentication state changes
  onAuthStateChanged(auth, userChangedACB);
}

export default app;
